/**
 * Тема из профиля — в каркасе приложения, а не на экране настроек.
 *
 * На старте тема берётся из локального хранилища: инлайновый скрипт в
 * `index.html` ставит её ещё до первого кадра, чтобы экран не мигал светлым.
 * Но хранилище на устройстве одно на всех, а `Profile.theme` у каждого
 * пользователя свой и синхронизируется между устройствами.
 *
 * Значение из профиля принимал единственный эффект — на экране «Профиль».
 * Пока туда не зайдёшь, приложение сидело в чужой теме: после входа под другим
 * аккаунтом, на новом устройстве или после переустановки. А в момент захода в
 * настройки тема менялась сама собой, будто её кто-то переключил.
 *
 * Профиль здесь — источник истины, и спорить с локальным выбором это не будет:
 * переключатель в настройках пишет и в стор, и в профиль, так что после его
 * нажатия значения совпадают и синхронизация ничего не меняет.
 */

import { useEffect } from 'react';

import { useProfile } from '@/entities/profile/model/use-profile';

import { useThemeStore } from './theme-store';

export function useProfileTheme(): void {
  const profile = useProfile();
  const syncFromProfile = useThemeStore((state) => state.syncFromProfile);

  const theme = profile?.theme;

  useEffect(() => {
    if (theme) syncFromProfile(theme);
  }, [theme, syncFromProfile]);
}
